import { createFileRoute } from '@tanstack/react-router';
import { ChatFeature } from '@/features/chat/ChatFeature';

/**
 * /chat layout route — owns the SidebarProvider + ChatSidebar wrapper.
 * Child index and $chatId routes render <Chat> inside the <Outlet>.
 */
export const Route = createFileRoute('/_app/chat')({
  component: ChatFeature,
});
